import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

const base = () => `${config().catalogueServiceBaseUrl}/back-office/admin-users`;

async function request(path, options) {
    const res = await fetchWithAuth(`${base()}${path}`, options);
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body?.error ?? res.statusText);
    }
    return res.status === 204 ? null : res.json();
}

const json = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
});

export const adminUsersProxy = {
    list: () => request(''),
    invite: (email, scopes) => request('', json('POST', { email, scopes })),
    update: (email, scopes) => request(`/${encodeURIComponent(email)}`, json('PUT', { scopes })),
    remove: (email) => request(`/${encodeURIComponent(email)}`, { method: 'DELETE' }),
};
